var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Offcanvas',{staticClass:"messages-offcanvas",attrs:{"config":_vm.modal}},[_c('Chat',{attrs:{"config":_vm.chat,"messagesLoaded":_vm.messagesLoaded},on:{"sendMessage":_vm.sendMessage,"selectChannel":_vm.selectChannel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }